import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-textarea-field',
  templateUrl: './textarea-field.component.html',
  styleUrl: './textarea-field.component.css'
})
export class TextareaFieldComponent implements ICellRendererAngularComp {
  currentField: any;
  refresh(_params: ICellRendererParams): boolean {
    return false;
  }
  params;

  agInit(params): void {
    this.params = params;
    this.currentField = this.params?.column?.colId
  }

  get displayTextAreaValue(): string {
    const context = this.params.context;
    const tempData = context.tempEditData?.[this.params.node.id];
    if (this.params.data.editable && tempData) {
      return tempData[this.params.colDef.field];
    }
    return this.params.data[this.params.colDef.field];
  }
    
  get showValidationError(): boolean {
    const context = this.params.context;
    return (
      (this.currentField === 'contingencyplan' || this.currentField === 'contigencyplansummary') &&
      !context.isContingencyValid(this.params.node.id)
    );
  }

  onTextAreaValueInput(newValue: any) {
    const context = this.params.context;
    const tempData = context.tempEditData?.[this.params.node.id];
    if (tempData) {
      tempData[this.params.colDef.field] = newValue;
      if(this.currentField === 'contigencyplansummary') {
        this.params.api.refreshCells({
          rowNodes: [this.params.node],
          columns: ['contingencyplan'],
          force: true
        });
      }
    }
  }
}
